module["exports"] = [
  "###-###",
  "#####"
];
